<template>
  <a-modal
    ref="createModal"
    title="详情"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    :footer="null"
  >
    <lsMetable
      class="editMaterial"
      :columns="columns"
      :data-list="dataList"
      :scroll="{ y:500, x: 2800 }"
      :IsEdit="false"
      :needAdd="false"
      :pagination="pagination"
      :loading="loading"
    >
    </lsMetable>
  </a-modal>
</template>

<script>
import { DAY_COLS } from '@/views/mes/productionPrepare/calcPieceworkWage/common'
import { apiDailySalaryList } from '@/api/mes/productionPrepare/ccPieceworkWage'
export default {
  name: 'MonthWageDetailModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    this.columns = JSON.parse(JSON.stringify(DAY_COLS)).filter(item => item.dataIndex !== 'operation');
    return {
      loading: true,
      visible: false,
      dataList: [],
      requiredRules: [{ required: true, message: ' ', trigger: 'change' }],
      baseData: {},
      pagination: {
        total: 0,
        pageSize: 31,
        current: 1
      }
    }
  },
  methods: {
    show(itemData) {
      this.visible = true
      this.baseData = { ...itemData };
      this.getDataList()
    },
    // 关闭模态框
    onClose() {
      this.dataList = [];
      this.visible = false
    },
    getDataList() {
      const { produceTime, employeeCode } = this.baseData;
      const params = {
        organizationCode: this.baseData.organizationCode,
        employeeCode,
        pageSize: 9999,
        pageNum: 1,
        produceTimeStart: this.$moment(produceTime).startOf('month').format('YYYY-MM-DD 00:00:00'),
        produceTimeEnd: this.$moment(produceTime).endOf('month').format('YYYY-MM-DD 23:59:59')
      };
      this.loading = true;
      this.dataList = [];
      this.pagination.current = 1;
      this.pagination.total = 0;
      apiDailySalaryList(params).then(res => {
        if(res.code === 200) {
          this.dataList = res.rows || [];
          this.pagination.total = this.dataList.length;
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style  scoped lang="less">
</style>
